import { Box, Button, Dialog, makeStyles, Typography } from "@material-ui/core";
import React from "react";

interface DialogSplitSucessProps {
  buttonText: string;
  isOpen: boolean;
  onClose: () => void;
  title: string;
}

const useStyles = makeStyles(
  {
    sucessDialogBox: {
      width: "420px",
      height: "170px",
      padding: "32px 24px",
      boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.25)",
      borderRadius: "16px"
    },
    title: {
      fontSize: "20px",
      fontWeight: 700,
      textAlign: "center"
    },
    buttonText: {
      fontSize: "18px",
      color: "white",
      fontWeight: 400,
      lineHeight: "24px"
    },
    button: {
      alignSelf: "center",
      backgroundColor: "#009FB8",
      borderRadius: "4px",
      width: "372px",
      height: "48px",
      marginTop: "30px"
    },
    succces: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      marginTop: "5px"
    }
  },
  { name: "DialogSplitSucess" }
);

const DialogSplitSucess = ({
  isOpen,
  onClose,
  title,
  buttonText
}: DialogSplitSucessProps) => {
  const classes = useStyles();

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      PaperProps={{
        style: { borderRadius: 16 }
      }}
    >
      <Box
        className={classes.sucessDialogBox}
        display="flex"
        flexDirection={"column"}
      >
        <div className={classes.succces}>
          <Typography className={classes.title}>{title}</Typography>
        </div>
        <Button id="closeButton" className={classes.button} onClick={onClose}>
          <Typography className={classes.buttonText}>{buttonText}</Typography>
        </Button>
      </Box>
    </Dialog>
  );
};

export default DialogSplitSucess;
